"use client";

import { useContext } from "react";
import { logEvent } from "@/service/logs/log";
import { ResourceContext } from "@/contexts/resource-context";
import { VirtualOfficeLogoWhiteIcon } from "@/svg/club/subscription/virtual-office-logo-white-icon";
import { Button } from "@/components/ui/button";
import { PictureAsset } from "@/components/common/picture-asset";
import { XIcon } from "lucide-react";

export const HomeVirtualOfficeBanner = ({
  closeBanner,
}: {
  closeBanner: () => void;
}) => {
  const { logView } = useContext(ResourceContext);

  const handleLinkClick = (type: string) => {
    return () =>
      logEvent("home_banner_button_click", logView, {
        banner_type: "virtual_office",
        banner_button_type: type,
      });
  };

  return (
    <div
      className={
        "relative my-10 w-full items-center gap-14 overflow-hidden rounded-2xl bg-[#1f1f1f] md:flex md:h-[200px]"
      }
    >
      <a
        href={"/klubmedyka/subskrypcja/wirtualne-biuro"}
        className="absolute inset-0 z-10 size-full"
      ></a>
      <div
        className={
          "absolute top-0 right-0 z-10 cursor-pointer p-4 md:top-2 md:right-2"
        }
      >
        <XIcon
          size={20}
          className={"z-20 text-white"}
          onClick={() => {
            closeBanner();
          }}
        />
      </div>
      <div className={"relative w-full p-8 md:w-auto"}>
        <div
          className={`relative z-5 mt-2 mb-6 flex items-center gap-6 text-xl font-semibold text-white xl:text-4xl`}
        >
          <VirtualOfficeLogoWhiteIcon /> Wirtualny gabinet
        </div>

        <div className={"relative flex flex-col gap-4 sm:flex-row"}>
          <Button
            asChild={true}
            variant={"outlineVirtualOffice"}
            className={"z-20 w-full md:w-auto"}
            onClick={handleLinkClick("details")}
          >
            <a href={"/klubmedyka/subskrypcja/wirtualne-biuro"}>
              Sprawdź szczegóły
            </a>
          </Button>
          <Button
            asChild={true}
            variant={"virtualOffice"}
            className={"z-20 w-full md:w-auto"}
            onClick={handleLinkClick("join")}
          >
            <a href={"/klubmedyka/subskrypcja/wirtualne-biuro"}>
              Dołącz za <strong>29 zł/mies.</strong>
            </a>
          </Button>
        </div>
        <div className={"mt-60 sm:mt-70 md:hidden"}>
          <PictureAsset
            source={
              "https://cdn.remedium.md/image/common/2025/11/10/10/mobile-png-6911b5a2c9f6f"
            }
            ext={"png"}
            alt={"Subskrypcje"}
            className={
              "absolute bottom-0 left-0 z-0 min-h-[500px] w-full object-cover object-bottom md:hidden"
            }
          />
        </div>
      </div>
      <div
        className={
          "relative z-10 hidden w-[420px] text-white [@media(min-width:1530px)]:block"
        }
      >
        Zachowaj pełną prywatność i chroń swoje dane osobowe.{" "}
        <strong>Zadbamy o Twój spokój i korespondencję.</strong>
      </div>
      <PictureAsset
        source={
          "https://cdn.remedium.md/image/common/2025/11/06/14/wb-graphic-3-png-690ca8cdc9871"
        }
        ext={"png"}
        alt={"Subskrypcje"}
        className={
          "absolute top-0 right-0 bottom-0 z-0 hidden aspect-[882/467] h-[286px] object-cover object-right md:block"
        }
      />
    </div>
  );
};
